<template>
	<div>
		<header class="page-title">
			<h2>Providers</h2>
			<div class="ml-auto">
				<a v-if="userRoles.includes('site_settings.update')" href="#" class="btn btn-md btn-success"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>

		<div class="grid--nav-horizontal">
			<nav class="nav-horizontal">
				<ul>
					<li :class="[activeHorizontalTabName === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in horizontalTabs" v-if="!tab.disabled">
						<span v-if="tab.disabled">{{ tab.displayName }}</span>
						<a @click.prevent="setActiveHorizontalTabName(tab.name)" v-if="!tab.disabled"> {{ tab.displayName }}</a>
					</li>
				</ul>
			</nav>
			<div class="nav-horizontal-contents">
				<div class="flex box">
					<div v-if="activeHorizontalTabName === 'horizontalReviews'" class="card six-lg">
						<header class="card-header">
							<h4 class="card-title">Reviews Top 3 Spots</h4>
						</header>
						<div class="card-body">
							<table>
								<thead>
									<tr>
										<th>Position</th>
										<th>Provider</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1.</td>
										<td>
											<select>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
											</select>
										</td>
									</tr>
									<tr>
										<td>2.</td>
										<td>
											<select>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
											</select>
										</td>
									</tr>
									<tr>
										<td>3.</td>
										<td>
											<select>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
											</select>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div v-if="activeHorizontalTabName === 'horizontalAllVpns'" class="card six-lg">
						<header class="card-header">
							<h4 class="card-title">All VPNS Top 3 Spots</h4>
						</header>
						<div class="card-body">
							<table>
								<thead>
									<tr>
										<th>Position</th>
										<th>Provider</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1.</td>
										<td>
											<select>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
											</select>
										</td>
									</tr>
									<tr>
										<td>2.</td>
										<td>
											<select>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
											</select>
										</td>
									</tr>
									<tr>
										<td>3.</td>
										<td>
											<select>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
											</select>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div v-if="activeHorizontalTabName === 'horizontalPostSidebar'" class="card six-lg">
						<header class="card-header">
							<h4 class="card-title">Post Sidebar Top 3 Spots</h4>
						</header>
						<div class="card-body">
							<table>
								<thead>
									<tr>
										<th>Position</th>
										<th>Provider</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1.</td>
										<td>
											<select>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
											</select>
										</td>
									</tr>
									<tr>
										<td>2.</td>
										<td>
											<select>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
											</select>
										</td>
									</tr>
									<tr>
										<td>3.</td>
										<td>
											<select>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
												<option>ExpressVPN</option>
											</select>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		props: {
			dataProviders: {
				type: Object
			},
		},
		data() {
			return {
				userRoles: this.$currentUserRoles,
				providers: this.dataProviders,
				horizontalTabs: [
					{
						name: 'horizontalReviews',
						displayName: 'Reviews',
						disabled: false
					},
					{
						name: 'horizontalAllVpns',
						displayName: 'All VPNs',
						disabled: false
					},
					{
						name: 'horizontalPostSidebar',
						displayName: 'Post Sidebar',
						disabled: false
					}
				],
				activeHorizontalTabName: null
			}
		},
		mounted() {
			this.activeHorizontalTabName = this.horizontalTabs[0].name;
		},
		methods: {
			setActiveHorizontalTabName: function (name) {
				this.activeHorizontalTabName = name;
			}
		}
	}
</script>

<style scoped>

</style>
